module.exports = __webpack_public_path__ + "static/img/Gold-Coast-Suns.e174bff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Gold-Coast-Suns.jpg
// module id = HHN5
// module chunks = 1